<template>
  <span class="date-picker">
      <span v-if="type === 'button'" class="btn btn-secondary" v-on:click="showPicker = !showPicker">
        <i class="fa-light fa-calendar-days"></i>
      </span>
      <p v-else v-on:click="showPicker = !showPicker" class="form-control mb-2">
        {{ selectedDate || '-' }}
      </p>
      <div v-show="showPicker" class="picker" style="text-align: center;">
        <button v-on:click="setPrevious()" class="float-start btn btn-secondary">vorige</button>
        <span>{{ monthText }} {{ year }}</span>
        <button v-on:click="setNext()" class="float-end btn btn-secondary">volgende</button>
        <hr>
        <span style="display: inline-block; width: 12.5%">wk</span>
        <span v-bind:key="day" v-for="day in weekDays" style="display: inline-block; width: 12.5%">
            {{ day }}
        </span>
        <span v-bind:key="date" v-for="(date, index) in days">
            <span v-if="index % 7 == 0">
            <br>
            </span>
            <span v-if="index % 7 == 0" style="display: inline-block; width: 12.5%">
              {{ this.$moment(date).format('W')}}
            </span>
            <span style="display: inline-block; width: 12.5%" v-on:click="setDate(date)">
                <span v-if="$moment(date).format('DD-MM-YYYY') == $moment().format('DD-MM-YYYY')" style="background: #cecece; padding: 4px; border-radius: 20%">
                    {{ this.$moment(date).format('D') }}
                </span>
                <span v-else-if="$moment(date).format('MM') == month">
                    {{ this.$moment(date).format('D') }}
                </span>
                <span v-else style="color: #cecece">
                    {{ this.$moment(date).format('D') }}
                </span>
            </span>
        </span>
        <hr>
        <div class="d-grid gap-2">
            <button v-on:click="selectedDate = null; showPicker = false" class="btn btn-secondary">Verwijder datum</button>
            <button v-on:click="showPicker = false" class="btn btn-secondary">Annuleren</button>
        </div>
    </div>
  </span>
</template>

<script>
export default {
  name: 'date-picker',
  props: {
    initDate: {
      default: null
    },
    listenToDate: {
      type: String
    },
    type: {
      type: String,
      default: 'input'
    }
  },
  created () {
    this.date = this.$moment()
    if (this.initDate) {
      this.setDate(this.initDate)
    }
    this.setDates(this.date)
    this.showPicker = false
  },
  watch: {
    listenToDate (date) {
      this.setDate(date, false)
    }
  },
  data () {
    return {
      showPicker: false,
      date: null,
      selectedDate: null,
      weekDays: [
        'ma.', 'di.', 'wo.', 'do.', 'vr.', 'za.', 'zo.'
      ],
      days: [],
      year: null,
      month: null,
      monthText: null,
      day: null
    }
  },
  methods: {
    setDates (date) {
      date = date || this.$moment()
      this.year = date.format('YYYY')
      this.month = date.format('MM')
      this.monthText = date.format('MMMM')
      this.day = date.format('DD')
      this.days = []
      var startOfMonth = date.startOf('month').format('YYYY-MM-DD hh:mm')
      var endOfMonth = date.endOf('month').format('YYYY-MM-DD hh:mm')
      var startOfMonthStartOfWeek = this.$moment(startOfMonth).startOf('week')
      var endOfMonthEndOfWeek = this.$moment(endOfMonth).endOf('week')
      var currentDate = startOfMonthStartOfWeek
      while (currentDate < endOfMonthEndOfWeek) {
        this.days.push(currentDate.format('YYYY-MM-DD'))
        currentDate = currentDate.add(1, 'days')
      }
      this.showPicker = true
    },
    setPrevious () {
      this.setDates(this.date.subtract(1, 'month'))
    },
    setNext () {
      this.setDates(this.date.add(1, 'month'))
    },
    setDate (date) {
      this.selectedDate = this.$moment(date).format('DD-MM-YYYY')
      if (date === this.listenToDate) {
        return
      }
      this.showPicker = false
      this.$emit('setDate', this.$moment(date))
    }
  }
}
</script>

<style scoped>
    .picker {
        background: white;
        padding: 10px;
    }
    .alert {
      padding: 6px;
      padding-left: 13px;
      padding-right: 13px;
    }
</style>
